import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import memoize from 'transmute/memoize';
import once from 'transmute/once';
export const multicurrencySettings = once(() => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/account-defaults/multicurrency`);
export const getProductLibraryHref = once(() => `/settings/${PortalIdParser.get()}/sales/products`);
export const getProductIndexHref = once(() => `/contacts/${PortalIdParser.get()}/objects/0-7`);
export const getProductIndexHrefWithCreatorOpen = once(() => `${getProductIndexHref()}?createNewObject=0-7`);
export const getProductIndexHrefWithBundleAssociations = memoize(productId => `${getProductIndexHref()}?filters=${JSON.stringify([
// Association 1210 can not be used on the index page advanced filters and should be equivalent to 1209
{
  operator: 'EQ',
  value: productId,
  property: 'associations.0-1209'
}])}`);
export const getTaxRateLibraryHref = once(() => `/settings/${PortalIdParser.get()}/sales/products/taxRates`);
export const getProductEditorCreateHref = once(() => `/products/${PortalIdParser.get()}/create`);